import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Paper, Grid, Typography, Collapse, Radio } from '@material-ui/core';
import Select from 'components/Select';
import Input from 'components/Input';
import CEP from 'components/CEP';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

import { loadSuperlogicaList } from '../../../store/thunk';

import { clearCharge, setCharge, setChargeType } from '../../../store/actions';

import { formatPostalCode, formatDocument } from 'helpers/formatters';

import { options } from './resources';

export default function Charge({ formikProps }) {
  const dispatch = useDispatch();

  const { values, errors, setFieldValue, handleChange } = formikProps;

  const { userId } = useSelector(state => state.profile);
  const { businessInfo, charge, superlogicaList } = useSelector(state => state.businessInfoRegistration);

  const slOption = superlogicaList?.find(superlogica => +superlogica?.value == +values?.superlogicaId);

  useEffect(() => {
    dispatch(loadSuperlogicaList(userId));
  }, []);

  return(
    <Paper style={{ padding: 30, marginBottom: 30 }}>
      <Grid container>
        <Grid item xs={12}>
          <Typography variant='h6'>
            <b>Como deseja vincular a cobrança deste estabelecimento?</b>
          </Typography>
        </Grid>
      </Grid>
      <Grid container>
        {options.map(option => {
          return(
            <>
              <Grid
                container
                xs={12}
                justify='flex-start'
                alignItems='center'
                style={{
                  gap: 10,
                  padding: 15,
                  marginTop: 20,
                  backgroundColor: charge?.chargeType == option.id ? 'rgba(79, 161, 91, 0.2)' : 'inherit',
                  border: charge?.chargeType == option.id ? '2px solid #4fa15b' : '2px solid #c4c4c4',
                  borderRadius: 8
                }}
              >
                <Radio
                  style={{ color: '#000000' }}
                  checked={charge?.chargeType == option.id}
                  onChange={() => {
                    setFieldValue('chargeType', option.id);

                    if(option.id == 'another_charge') {
                      dispatch(setCharge({
                        chargeType: option.id,
                        newClientSl: 1,
                        superlogicaId: '',
                        establishmentName: businessInfo?.establishmentName,
                        documentId: businessInfo?.documentId,
                        email: businessInfo?.email,
                        phone: businessInfo?.phone,
                        postalCode: businessInfo?.postalCode,
                        street: businessInfo?.street,
                        number: businessInfo?.number,
                        complement: businessInfo?.complement,
                        district: businessInfo?.district,
                        city: businessInfo?.city,
                        state: businessInfo?.state
                      }));
                      return;
                    }

                    const isSwitchingChargeOption = (
                      (charge?.chargeType == 'existing_charge' && option.id == 'same_charge') ||
                      (charge?.chargeType == 'same_charge' && option.id == 'existing_charge')
                    );

                    dispatch(setChargeType(option.id));
                    dispatch(clearCharge());

                    if(isSwitchingChargeOption) {
                      setFieldValue('superlogicaId', '');
                      dispatch(setCharge({ superlogicaId: '' }));
                    }
                  }}
                />
                <div>
                  <Typography variant='subtitle2'>
                    <b>{option.title}</b>
                  </Typography>
                  <Typography variant='subtitle2' color='textSecondary'>
                    {option.description}
                  </Typography>
                </div>
              </Grid>
              <Collapse in={charge?.chargeType == option.id} style={{ width: '100%', marginTop: 20 }}>
                {(option.id == 'existing_charge') && (
                  <Grid item xs={12}>
                    <Typography variant='subtitle2' color='textSecondary'>
                      Selecione o CNPJ/cobrança existente
                    </Typography>
                    <Select
                      name="superlogicaId"
                      label="Selecione o CNPJ/cobrança existente"
                      options={superlogicaList}
                      value={values.superlogicaId}
                      error={errors.superlogicaId}
                      helperText={errors.superlogicaId}
                      onChange={event => {
                        setFieldValue(event.target.name, event.target.value);
                        setFieldValue('newClientSl', 0);
                      }}
                    />
                    <Grid container justify='flex-start' alignItems='center' style={{ gap: 10, padding: 15, marginTop: 20, backgroundColor: '#ecf7fe', border: '2px solid #6aa4dd', borderRadius: 8 }}>
                      <FontAwesomeIcon
                        size='lg'
                        color='#6aa4dd'
                        icon={faExclamationCircle}
                      />
                      <Typography variant='subtitle2' style={{ color: '#6aa4dd' }}>
                        <b>A primeira cobrança será paga separadamente. Nas próximas cobranças, o novo estabelecimento passará a compor a mesma cobrança/fatura selecionada, inclusive para boleto, PIX ou cartão.</b>
                      </Typography>
                    </Grid>
                  </Grid>
                )}
                {(option.id == 'same_charge') && (
                  <Grid item xs={12}>
                    <Select
                      name="superlogicaId"
                      label="Selecione o CNPJ/cobrança existente"
                      options={superlogicaList}
                      value={values.superlogicaId}
                      error={errors.superlogicaId}
                      helperText={errors.superlogicaId}
                      onChange={event => {
                        setFieldValue(event.target.name, event.target.value);
                        setFieldValue('newClientSl', 1);
                      }}
                    />
                    <Grid container style={{ backgroundColor: 'rgba(196, 196, 196, 0.1)', border: '2px solid #c4c4c4', borderRadius: 8, padding: 20, marginTop: 10 }}>
                      <Grid item xs={12}>
                        <Typography>
                          <b>Confirmar dados do CNPJ/CPF</b>
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Grid container style={{ marginTop: 10 }}>
                          <Grid item md={6} xs={12}>
                            <Typography variant='body2' color='textSecondary'>
                              Razão Social
                            </Typography>
                            <Typography>
                              {slOption?.name}
                            </Typography>
                          </Grid>
                          <Grid item md={6} xs={12}>
                            <Typography variant='body2' color='textSecondary'>
                              Nome Fantasia
                            </Typography>
                            <Typography>
                              {slOption?.fantasyName}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid container style={{ marginTop: 10 }}>
                          <Grid item md={6} xs={12}>
                            <Typography variant='body2' color='textSecondary'>
                              CNPJ/CPF
                            </Typography>
                            <Typography>
                              {slOption?.documentId ? formatDocument(slOption?.documentId) : '-'}
                            </Typography>
                          </Grid>
                          <Grid item md={6} xs={12}>
                            <Typography variant='body2' color='textSecondary'>
                              Endereço
                            </Typography>
                            <Typography>
                              -
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
                {(option.id == 'another_charge') && (
                  <Grid item xs={12} style={{ border: '2px solid #c4c4c4', borderRadius: 8, padding: 20 }}>
                    <Grid container>
                      <Grid item xs={12}>
                        <Typography>
                          <b>Dados do novo CNPJ/CPF de cobrança</b>
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} style={{ marginTop: 10 }}>
                      <Grid item md={6} xs={12}>
                        <Typography variant='subtitle2' color='textSecondary'>
                          Nome Completo / Razão Social
                        </Typography>
                        <Input
                          name="establishmentName"
                          label="Nome Completo / Razão Social"
                          value={values.establishmentName}
                          error={errors.establishmentName}
                          helperText={errors.establishmentName}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item md={6} xs={12}>
                        <Typography variant='subtitle2' color='textSecondary'>
                          CNPJ/CPF
                        </Typography>
                        <Input
                          name="documentId"
                          type="document"
                          label="CNPJ/CPF"
                          placeholder="00.000.000/0000-00"
                          value={values.documentId}
                          error={errors.documentId}
                          helperText={errors.documentId}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item md={6} xs={12}>
                        <Typography variant='subtitle2' color='textSecondary'>
                          E-mail de cobrança
                        </Typography>
                        <Input
                          name="email"
                          type="email"
                          label="Email de cobrança"
                          placeholder="usuario@exemplo.com.br"
                          value={values.email}
                          error={errors.email}
                          helperText={errors.email}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item md={6} xs={12}>
                        <Typography variant='subtitle2' color='textSecondary'>
                          Telefone de cobrança
                        </Typography>
                        <Input
                          noAutoComplete
                          name="phone"
                          type="phone"
                          label="Telefone de cobrança"
                          placeholder="(00) 00000-0000"
                          value={values.phone}
                          error={errors.phone}
                          helperText={errors.phone}
                          onChange={handleChange}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item md={4} xs={12}>
                        <Typography variant='subtitle2' color='textSecondary'>
                          CEP
                        </Typography>
                        <CEP
                          name="postalCode"
                          type="postalCode"
                          label="CEP"
                          value={values.postalCode}
                          error={errors.postalCode}
                          helperText={errors.postalCode}
                          onInputChange={postalCode => setFieldValue('postalCode', postalCode)}
                          onChange={postalCode => {
                            if (!postalCode.erro) {
                              const { cep, logradouro, complemento, bairro, localidade, uf } = postalCode;

                              setFieldValue('postalCode', formatPostalCode(cep));
                              setFieldValue('street', logradouro);
                              setFieldValue('complement', !complemento ? values.complement : complemento);
                              setFieldValue('district', bairro);
                              setFieldValue('city', localidade);
                              setFieldValue('state', uf);
                            }
                          }}
                        />
                      </Grid>
                      <Grid item md={8} xs={12}>
                        <Typography variant='subtitle2' color='textSecondary'>
                          Endereço
                        </Typography>
                        <Input
                          name="street"
                          type="text"
                          label="Endereço"
                          placeholder="Endereço"
                          maxLength={255}
                          value={values.street}
                          error={errors.street}
                          helperText={errors.street}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item md={4} xs={12}>
                        <Typography variant='subtitle2' color='textSecondary'>
                          Número
                        </Typography>
                        <Input
                          name="number"
                          type="number"
                          label="Número"
                          placeholder="0"
                          maxLength={8}
                          value={values.number}
                          error={errors.number}
                          helperText={errors.number}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item md={8} xs={12}>
                        <Typography variant='subtitle2' color='textSecondary'>
                          Complemento (opcional)
                        </Typography>
                        <Input
                          name="complement"
                          type="text"
                          label="Complemento"
                          placeholder="Ex.: 3˚ andar"
                          maxLength={50}
                          value={values.complement}
                          error={errors.complement}
                          helperText={errors.complement}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item sm={4} xs={12}>
                        <Typography variant='subtitle2' color='textSecondary'>
                          Bairro
                        </Typography>
                        <Input
                          name="district"
                          type="text"
                          label="Bairro"
                          placeholder="Bairro"
                          maxLength={50}
                          value={values.district}
                          error={errors.district}
                          helperText={errors.district}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item sm={6} xs={12}>
                        <Typography variant='subtitle2' color='textSecondary'>
                          Cidade
                        </Typography>
                        <Input
                          name="city"
                          type="text"
                          label="Cidade"
                          placeholder="Cidade"
                          maxLength={50}
                          value={values.city}
                          error={errors.city}
                          helperText={errors.city}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item sm={2} xs={12}>
                        <Typography variant='subtitle2' color='textSecondary'>
                          UF
                        </Typography>
                        <Input
                          name="state"
                          type="text"
                          label="UF"
                          placeholder="UF"
                          maxLength={2}
                          value={values.state}
                          error={errors.state}
                          helperText={errors.state}
                          onChange={handleChange}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Collapse>
            </>
          );
        })}
        {!!errors.chargeType && (
          <Grid item xs={12} style={{ marginTop: 16 }}>
            <Typography color='error'>
              {errors.chargeType}
            </Typography>
          </Grid>
        )}
      </Grid>
    </Paper>
  );
}